import i18n from '@/utils/i18n';
import React from 'react';
import { Button, Icons } from '@usepepper/sprout-kit-ui';
import { openPmcPayments } from '@finance-hub/blocs/utils/open-pmc';

export const GoToPmcSidebarButton: React.FC = () => (
  <Button
    borderColor="$borderPrimary"
    borderRadius={8}
    borderStyle="dashed"
    borderWidth={1}
    fullWidth
    icon={<Icons.ArrowRight color="$iconSecondary" />}
    justifyContent="flex-start"
    marginBottom={16}
    onPress={() => {
      void openPmcPayments();
    }}
    size="$md"
    textProps={{ color: '$textSecondary' }}
    variant="tertiary"
  >
    {i18n.t('finance_hub.sidebar.go_to_pmc')}
  </Button>
);
